import { render, staticRenderFns } from "./cbfUserPortal.vue?vue&type=template&id=92753be4&scoped=true&"
import script from "./cbfUserPortal.vue?vue&type=script&lang=js&"
export * from "./cbfUserPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92753be4",
  null
  
)

export default component.exports